module.exports = __webpack_public_path__ + "static/DINPro-Light-aa1d69c7671f70a4720e20188a1ffd17.woff2";